<template>
  <div>
    <b-row style="background-color: #1ab394;color: white; padding-bottom:10px; padding-top:10px">
      <FormGroup
        cols="12"
        :label="'Seleccione un widget para ' + (tipo == 'agregar' ? 'agregar':'reemplazar')">
        <b-skeleton type="input" v-if="loading" ></b-skeleton>
        <v-select 
          v-else
          @input="onChangeWidget"
          v-model="widget.id_widget" 
          :clearable=false
          label="nombre_widget"
          :options="widgets" 
          :reduce="option=>option.id_widget">
        </v-select>
      </FormGroup>
      <FormGroup
        cols="12"
        label="Ancho">
          <v-select 
            @input="$emit('modificacion-widget',widget, index)"
            v-model="widget.ancho"
            :clearable=false
            :reduce="habilitado=>habilitado.v"
            :options="[{v:'4',label:'33%'},{v:'6',label:'50%'},{v:'8',label:'66%'},{v:'12',label:'100%'}]">
          </v-select>
      </FormGroup>
      <b-col cols="12" align="right">
        <b-button v-if="loading" variant="primary"><Loading :size="'1'" :text="'Cargando widgets'"/></b-button>
        <b-button v-else-if="tipo == 'agregar'" variant="primary" v-on:click="$emit('agregar-widget',widget)">Agregar widget</b-button>
        <b-button v-else variant="primary" v-on:click="$emit('reemplazar-widget',widget, index)">Reemplazar widget</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { widgetService } from '@/services';

export default {
  props:['ancho','tipo','index'],
  data(){
    return {
      loading: true,
      widgets:[],
      widget:{
        id_widget:0,
        ancho:this.ancho
      }
    }
  },
  mounted(){
    this.cargarDatos();
  },
  methods : {
    cargarDatos(){
      this.loading = true;

      widgetService.getWidgets({}).then(respuesta => {
        this.widgets = respuesta.data;

        this.widget.id_widget = this.widgets[0].id_widget;
        this.widget.function = this.widgets[0].function;
        this.widget.nombre_widget = this.widgets[0].nombre_widget;
        
        this.loading = false;
      });
    },
    onChangeWidget(id_widget){
      let data = this.widgets.find((element) => element.id_widget == id_widget);

      this.widget.id_widget = data.id_widget;
      this.widget.function = data.function;
      this.widget.nombre_widget = data.nombre_widget;
    }
  }
}
</script>

<style>
  .vs__dropdown-toggle{
    background-color: white;
  }
  .vs__dropdown-menu{
    color:black;
  }
</style>
